import { ReactNode } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faCircleQuestion } from "@fortawesome/free-solid-svg-icons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type DashIconVariant = "accent" | "good" | "warning" | "critical" | "accent2";

interface DashCardProps {
  children: ReactNode;
  accent?: "critical";
  hoverable?: boolean;
  className?: string;
}

export const DashCard = ({ children, accent, hoverable = true, className = "" }: DashCardProps) => (
  <div
    className={`dash-card ${hoverable ? "dash-card--hoverable" : ""} ${
      accent === "critical" ? "dash-card--accent" : ""
    } ${className}`}
  >
    {children}
  </div>
);

interface DashCardHeaderProps {
  icon: IconDefinition;
  variant?: DashIconVariant;
  title: string;
  subtitle?: string;
  tooltip?: string;
  trailing?: ReactNode;
}

export const DashCardHeader = ({
  icon,
  variant = "accent",
  title,
  subtitle,
  tooltip,
  trailing,
}: DashCardHeaderProps) => (
  <div className="dash-card-header">
    <div className="dash-card-header-main">
      <div className={`dash-card-icon dash-card-icon--${variant}`}>
        <FontAwesomeIcon icon={icon} />
      </div>
      <div>
        <h6 className="dash-card-title">
          {title}
          {tooltip && (
            <OverlayTrigger placement="top" overlay={<Tooltip>{tooltip}</Tooltip>}>
              <FontAwesomeIcon icon={faCircleQuestion} className="dash-help" />
            </OverlayTrigger>
          )}
        </h6>
        {subtitle && <p className="dash-card-subtitle">{subtitle}</p>}
      </div>
    </div>
    {trailing}
  </div>
);

interface DashCardBodyProps {
  children: ReactNode;
  flush?: boolean;
}

export const DashCardBody = ({ children, flush = false }: DashCardBodyProps) => (
  <div className={flush ? "dash-card-body--flush" : "dash-card-body"}>{children}</div>
);
